import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './VerificationPopup';
import {
  getVerificationEmailAddress,
  getVerificationLoadingState,
} from '../publicSession/selectors';
import { openUserDropdown } from '../SiteHeader/redux/actions';
import { resendVerificationEmail } from '../publicSession/actions';
import { dropFirstTimeFlag } from '../redux/firstTimeFlags/actions';

export type StateProps = Pick<Props, 'email' | 'isSendingDone'>;
export type DispatchProps = Pick<
  Props,
  'changeEmail' | 'resendEmail' | 'dropFirstTimeFlag'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  email: getVerificationEmailAddress(state)!,
  isSendingDone: getVerificationLoadingState(state)?.isSendingDone,
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  changeEmail: openUserDropdown,
  resendEmail: resendVerificationEmail,
  dropFirstTimeFlag,
};

export default connect(mapStateToProps, mapDispatchToProps);
